module.exports = __webpack_public_path__ + "assets/img/img_2021.1ebedab0.jpg";